<div class="rd-procedures repair-diagram-content flex-row" *ngIf="procedures.length">
  <!-- Dialog Left Side Content -->
  <div class="repair-diagram-content-left">
    <!-- List of Procedures -->
    <div class="repair-diagram-list flex-column" *ngIf="!isProceduresSelected">
      <div *ngFor="let procedure of procedures" class="repair-diagram-list-item flex-start-center pointer"
        [ngClass]="{'active': procedure?.applicationId === selectedProcedure?.applicationId}"
        (click)="selectedProcedure = procedure; getProceduresDetails(procedure)">
        <p class="mb-0 flex-column">
          <span class="font-600 capitalize">{{procedure?.displayName}}</span>
          <span>{{procedure?.description}}</span>
        </p>
      </div>
    </div>

    <!-- List of Procedures Drilldown if any -->
    <div class="repair-diagram-list flex-column" *ngIf="isProceduresSelected">
      <div class="repair-diagram-list-item flex-start-center pointer" (click)="handleBack()">
        <i class="fal fa-chevron-left p-2"></i>

        <p class="mb-0 font-600 capitalize text-truncate" tooltipPosition="top"
          [pTooltip]="selectedProcedures?.displayName">
          {{selectedProcedures?.displayName}}
        </p>
      </div>

      <div *ngFor="let option of selectedProcedures?.details"
        class="repair-diagram-list-item flex-start-center pointer">
        <p class="mb-0 font-600 capitalize">
          {{option?.elementRef}} - {{option?.name}}
        </p>
      </div>
    </div>
  </div>

  <!-- Dialog Right Side Content -->
  <div class="repair-diagram-content-right p-2" [hidden]="isLoading">
    <div class="font-12" [innerHTML]="htmlProcedure"></div>

    <p class="font-bold mt-2 mb-2" [hidden]="!images?.length">Figures</p>

    <div class="flex-start-center flex-row flex-wrap" [hidden]="!images?.length">
      <div class="procedure-image mt-4 mb-2 pointer" *ngFor="let image of images; let imageIndex = index"
        [id]="image?.anchorDocumentId" (click)="openFigureDialog(image)">
        <img [src]="image?.image" [alt]="image?.caption">
        <p class="m-0 text-center">Fig. {{imageIndex + 1}}. {{image?.caption}}</p>
      </div>
    </div>
  </div>

  <div class="repair-diagram-content-right p-2" [hidden]="!isLoading">
    <div class="flex-start-center font-14">
      <span class="pr-2">Loading...</span>
      <i class="fal fa-spinner rotate"></i>
    </div>
  </div>
</div>

<div class="rd-procedures repair-diagram-content" *ngIf="!procedures.length">
  <div class="flex-center-center procedure-service flex-column">
    <img src="../../../../../../assets/img/empty-icon-diagrams.svg" alt="" />
    <div class="pr-2 font-12 pt-2 font-gray-35">There are no procedures associated with this service.
    </div>
  </div>
</div>
